function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.8538 11.0288C22.6484 10.7477 17.7526 4.14648 11.4999 4.14648C5.24716 4.14648 0.3512 10.7477 0.145951 11.0285C-0.0486505 11.2952 -0.0486505 11.6568 0.145951 11.9235C0.3512 12.2046 5.24716 18.8058 11.4999 18.8058C17.7526 18.8058 22.6484 12.2045 22.8538 11.9237C23.0487 11.6571 23.0487 11.2952 22.8538 11.0288ZM11.4999 17.2893C6.89408 17.2893 2.90497 12.908 1.72411 11.4756C2.90344 10.042 6.8842 5.66296 11.4999 5.66296C16.1055 5.66296 20.0943 10.0436 21.2757 11.4767C20.0963 12.9102 16.1156 17.2893 11.4999 17.2893Z",
  fill: "#90919C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5626 14.9562C9.62205 14.9562 8.04346 13.3776 8.04346 11.4371C8.04346 9.49661 9.6221 7.91797 11.5626 7.91797C13.5031 7.91797 15.0817 9.49661 15.0817 11.4371C15.0817 13.3776 13.5031 14.9562 11.5626 14.9562Z",
  fill: "#90919C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5626 14.9562C9.62205 14.9562 8.04346 13.3776 8.04346 11.4371C8.04346 9.49661 9.6221 7.91797 11.5626 7.91797C13.5031 7.91797 15.0817 9.49661 15.0817 11.4371C15.0817 13.3776 13.5031 14.9562 11.5626 14.9562Z",
  fill: "#90919C"
});

var SvgEyeOpen = function SvgEyeOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye_open.3d36f63c.svg";
export { ForwardRef as ReactComponent };